import React from 'react';
import { addLocaleData, IntlProvider, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import heLocaleData from 'react-intl/locale-data/he';
import enLocaleData from 'react-intl/locale-data/en';

import diskEn from './Translations/en.json';
import diskHe from './Translations/he.json';

// What the server loaded from the locale service on its last boot (/styles/locales), over the files
// bundled at build time - so a string added there needs a restart, not a rebuild.
const heFromServer = (window.locales && window.locales['he-IL']) || {};
const enFromServer = (window.locales && window.locales['en-US']) || {};

const heFromTheme = (window.theme && window.theme.locale && window.theme.locale.he) || {};
const enFromTheme = (window.theme && window.theme.locale && window.theme.locale.en) || {};

const he = { ...diskHe, ...heFromServer, ...heFromTheme };
const en = { ...diskEn, ...enFromServer, ...enFromTheme };

addLocaleData(heLocaleData);
addLocaleData(enLocaleData);

// This function will map the current redux state to the props for the component that it is "connected" to.
// When the state of the redux store changes, this function will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
function mapStateToProps(state) {
	const { lang } = state.identify;
	return { locale: lang, messages: lang === 'he-IL' ? he : en, isRTL: lang === 'he-IL' };
}

const LangProvider = connect(mapStateToProps)(IntlProvider);

const intlWithDirection = (Component) => {
	const Wrapped = injectIntl((props) => {
		const { intl, ...rest } = props;
		const isRTL = intl.locale && intl.locale.startsWith('he'); // or more advanced

		return <Component {...rest} intl={intl} isRTL={isRTL} />;
	});

	Wrapped.displayName = `withIntlExtras(${Component.displayName || Component.name})`;

	return Wrapped;
};

export {
	he,
	en,
	LangProvider,
	intlWithDirection
}
